import { render, staticRenderFns } from "./AppearanceColorTable.vue?vue&type=template&id=5f0bc68c&scoped=true&"
import script from "./AppearanceColorTable.vue?vue&type=script&lang=js&"
export * from "./AppearanceColorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0bc68c",
  null
  
)

export default component.exports